module.exports = __webpack_public_path__ + "img/1x.7b3b3ae.jpg";